export const actionSymbol = '$ep_a';
export const actionOnSymbol = '$ep_aO';
export const computedSymbol = '$ep_c';
export const effectOnSymbol = '$ep_e';
export const persistSymbol = '$ep_p';
export const reducerSymbol = '$ep_r';
export const thunkOnSymbol = '$ep_tO';
export const thunkSymbol = '$ep_t';
